export const militaryOptions = [
  { label: 'Active', value: 'Active' },
  {
    label: 'Reserve',
    value: 'Reserve',
  },
  {
    label: 'Retired',
    value: 'Retired',
  },
  {
    label: 'Honorably Discharged',
    value: 'Honorably Discharged',
  },
  {
    label: 'None',
    value: 'None',
  },
];
